import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalLenght'
})

export class NormalLenghtPipe implements PipeTransform {

  constructor(
  ) {

  }

  transform(data: any, lenght?: number): any {

    var value: any;

    if (typeof data == 'object') {
      value = data[0];
    } else {
      value = data;
    }

    if (typeof data == 'string') {
      return value;
    }

    if (lenght == null) {
      return value.substring(0, 15);
    }

    return value.substring(0, lenght);
  }

}
